
export class GenericConfig {
    public  static getVAOBaseUrl() : string {
        return "https://vaoproxy.dfi-ooevg.at/api/";
        //return "https://vaoproxy.possuite.emmgt.at/api/";
        // return "http://localhost:64937/api/";
        //return "https://vaoproxy-integration.azurewebsites.net/api/";
    }
    public static getNRBaseUrl(): string{
        //return "https://possuite.emmgt.at/V35/RESTService/";
        return "https://services.dfi-ooevg.at/RestService/";
        //return "http://localhost:64964/";
    }

    public static IsConsoleLoggerEnabled() {
        return true;
    }

    public static Lines() {
        return 9;
    }
}